<template>
  <div class="footer">
    <p>魔镜洞察的数据全部来自公开页面，魔镜洞察与淘宝、天猫、京东、亚马逊等电商平台无直接关联，是一家独立的第三方电商数据机构</p>
    <p class="text-footer"> ©2025 北京淘幂科技有限公司
      <a href="https://beian.miit.gov.cn/"
         target="_blank">京ICP备15061734号-4</a>|
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037832"
         target="_blank">
        京公网安备 11010502037832号
      </a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="less">
.footer {
  width: 100%;
  color: #d0d0d0;
  font-size: 12px;
  margin-top: 5px;
  background-color: #f4f5fa;
  p {
    text-align: center;
    margin-top: 0;
    margin-bottom: 0;
  }
  .text-footer {
    color: #d0d0d0;
    a {
      color: #d0d0d0;
    }
    a:hover,
    a:focus {
      color: #23527c;
    }
  }
}
</style>
